module.exports = __webpack_public_path__ + "p1_img3.jpg?13880b617aed909b4a078e2ca5539a96";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img3.jpg
// module id = 175
// module chunks = 0